import { FC } from "react";

import { usePageContext } from "@ryde/redux";
import { RydeUiUnit } from "@ryde/shared";

import {
  BulkOperationsCourseDrawer,
  BulkOperationsDefaultDrawer,
  BulkOperationsPassengersDrawer,
  BulkOperationsPriceRateDrawer,
} from "./parts";

const operationDrawerMap: Partial<Record<RydeUiUnit, FC>> = {
  passenger: BulkOperationsPassengersDrawer,
  priceRate: BulkOperationsPriceRateDrawer,
  course: BulkOperationsCourseDrawer,
};

export const ClientSideBulkOperationDrawerFlow: FC = () => {
  const { entity } = usePageContext();

  const OperationsDrawer = operationDrawerMap[entity];

  if (!OperationsDrawer) {
    return <BulkOperationsDefaultDrawer />;
  }

  return <OperationsDrawer />;
};
